export default __webpack_public_path__ + "scene5_2_bg3a7ca3.png";